// extracted by mini-css-extract-plugin
export var arrows = "_5j-5";
export var decrementer = "_5j-9";
export var disabled = "_5j-3";
export var error = "_5j-1";
export var hiddenText = "_5j-a";
export var incrementer = "_5j-8";
export var input = "_5j-7";
export var inputWrapper = "_5j-0";
export var leadingIcon = "_5j-b";
export var readonly = "_5j-2";
export var regular = "_5j-6";
export var small = "_5j-4";